import React from "react";
import {useNavigate} from "react-router-dom";
import {Grid, Card, Space, Row} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import GraphicChip from "../../Components/GraphicChip";
import PortfolioPageCard from "../../Pages/Portfolio/PortfolioPageCard";

const DashboardCards = ({portfolios})=>{

    const navigate = useNavigate();
    const signalTextColor = portfolios.length > 0 ? '#fff' : '#fff';
    const size = {width: 180, height: 95};
    const CrmCard = <GraphicChip
        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/homescreenGraphics/modern-black-bookcase.jpeg'}
        title={'CRM & Reporting'}
        tag={'Open'}
        onClick={()=>{
            window.open('https://main.yhlsoft.com/auth/users/sign_in?scope=auth&is_timeout=0&redirect_uri=https%3A%2F%2Fmain.yhlsoft.com%2Fhome%2Fv2%2Fstrategist_portal%3Fbranch_id%3D88888888-8888-8888-8888-888888888888%26prod%3DMMP%23%2FmodelPending')
        }}
        backgroundSize={'100% 100%'}
        textColor={signalTextColor}
        showIcon={true}
        size={size}
    />
    const SignalCard = <GraphicChip
        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/homescreenGraphics/city-at-night.jpeg'}
        title={'Trading Signals'}
        tag={portfolios.length > 0 ? `${portfolios.length} Signals` : <CheckOutlined color={'white'}/>}
        onClick={()=>{
            navigate('/signals')
        }}
        backgroundSize={'cover'}
        textColor={signalTextColor}
        tagWeight={portfolios.length>0?'700':'300'}
        showIcon={true}
        size={size}
    />

    return (

          <Row gutter={[0, 0]} wrap={true} justify={'start'} className={'px-4'}>
            {/*We set xs=12 and lg=24 since on xs and md it will be fullscreen */}
              {SignalCard}
              <PortfolioPageCard size={size}/>
              {CrmCard}
          </Row>
    )
}


export default DashboardCards;